import Config from '../launch/config'
import Matter from 'matter-js'
import Effects from '../effects/effects'
import {_addToEventLog, forceAppUpdate} from '../app/app'

export const orbitTowable = (entity, towableId) => {
    const towable = Config.towables[towableId]

    if (towable.isInOrbit) {
        return
    }

    // Set towable orbit props, remove constraint
    towable.orbitingEntity = entity
    towable.isBeingTowed = false
    towable.constraint &&
        Config.scene.matter.world.removeConstraint(towable.constraint)

    entity.orbitingTowables[towableId] = {
        id: towableId,
    }

    Matter.Body.set(towable.sprite.body, {
        frictionAir: 0.03,
        restitution: 0.1,
    })

    // Remove ship tow lines. Towable may not have a tow ship, it may be knocked into orbit
    if (towable.towShipId) {
        const ship = Config.ships[towable.towShipId]
        const towLine = ship && ship.towLines[towable.id]

        if (!towLine) {
            return
        }

        towLine.graphics && towLine.graphics.clear()
        towLine.graphics.destroy()

        delete ship.towLines[towable.id]
    }

    // When loading and assigning towables to orbit, do not give points and log event
    if (Config.isGameLoading) {
        return
    }

    // Points!
    new Effects().scoreAnim({
        x: towable.sprite.x,
        y: towable.sprite.y,
        num: Config.difficultyLevels[Config.difficulty].planetTowablePoints,
        positive: true,
    })

    if (
        towable.type === 'artifact' &&
        entity.faction === Config.userFactionName
    ) {
        _addToEventLog({
            coords: {x: entity.x, y: entity.y},
            html: `An artifact has been collected on <span style="color: #${Config.colorGreen}">${entity.name}</span>`,
        })
    }

    setTimeout(() => {
        forceAppUpdate()
    }, 0)
}
